import { useState, useEffect } from "react";

const useOrientation = () => {
    // 가로모드 체크
    const getIsLandscape = () => window.innerWidth > window.innerHeight;

    // 세로모드 체크
    const getIsPortrait = () => window.innerWidth < window.innerHeight;

    const [isLandscape, setIsLandscape] = useState(getIsLandscape());
    const [isPortrait, setIsPortrait] = useState(getIsPortrait());

    useEffect(() => {
        const handleResize = () => {
            const newIsLandscape = getIsLandscape();
            const newIsPortrait = getIsPortrait();

            if (newIsLandscape !== isLandscape) {
                setIsLandscape(newIsLandscape);
            }

            if (newIsPortrait !== isPortrait) {
                setIsPortrait(newIsPortrait);
            }
        };

        const handleOrientationChange = () => {
            const newIsLandscape = getIsLandscape();
            const newIsPortrait = getIsPortrait();

            if (newIsLandscape !== isLandscape) {
                setIsLandscape(newIsLandscape);
            }

            if (newIsPortrait !== isPortrait) {
                setIsPortrait(newIsPortrait);
            }
        };

        window.addEventListener("resize", handleResize); // 화면 크기 변경 시 감지
        window.addEventListener("orientationchange", handleOrientationChange); // 화면 회전 시 감지

        return () => {
            window.removeEventListener("resize", handleResize); // 이벤트 핸들러 제거
            window.removeEventListener("orientationchange", handleOrientationChange);
        };
    }, [isLandscape, isPortrait]); // 상태가 변경되었을 때만 실행

    return { isLandscape, isPortrait }; // 가로모드와 세로모드 상태 반환 (true/false)
};

export default useOrientation;
